define('app/sdc/file/type/sdc-file-type-factory',[],function() {
	var mimeTypeWoParams = /^([^/]+)\/(?:([^.]+)\.)?([^+.]+)(?:\+([^;]+))?$/;
	function extendFile(file) {
	}
	return sdcFileTypeFactory;
	function sdcFileTypeFactory(fullType) {
		if (!angular.isString(fullType)) {
			return {
				toString: function toString() {
					return fullType;
				},
				valueOf: function valueOf() {
					return fullType;
				}
			};
		}
		var typeParts = fullType.split(";"), 
		mimeParts = mimeTypeWoParams.exec(typeParts[0]) || angular.empty;
		return {
			full: fullType,
			type: mimeParts[1],
			tree: mimeParts[2],
			subType: mimeParts[3],
			suffix: mimeParts[4],
			params: typeParts.slice(1),
			toString: function toString() {
				return fullType;
			},
			valueOf: function valueOf() {
				return fullType;
			}
		};
	}
	;
});

